import {
  SET_COMMON_CONFIG,
  SET_MULTI_COMMON_CONFIG
} from "./actionTypes"

const initialState = {
  app_type: 'desktop',
  country_name: null,
  gameId: 202,
  gameType: null,
  subGameOnOffStatus: 1,
  marketCloseStatus: 1,
  discount: {
    showMultiple: 1000,
  },
  marketList: [],
  clickTab: 0,
  backend_coach_mark_status: false,
  subGameType: null,
  promoStatus: 0,
  coachMarkStatus: 0,
}

const CommonConfig = (state = initialState, action) => {
  let tempState = { ...state };
  switch (action.type) {
    case SET_COMMON_CONFIG:
      tempState[action.payload.key] = action.payload.value;
      state = { ...state, ...tempState };
      break
    case SET_MULTI_COMMON_CONFIG:
      state = { ...state, ...action.payload };
      break
  }
  return state
}

export default CommonConfig